<!--  progrem essay edit -->
<template>
  <div class="program-essay-edit">
    <essay-list></essay-list>
    <!-- 讨论区 -->
    <div class="essay-edit-dicuss">
      <div>
        <div class="essay-edit-dicuss-con">
          <zlr-discuss title="Discussion">
            <template v-if="commentList && commentList.length>0">
              <zlr-discuss-item v-for="(item, index) in commentList"
                                :key="index"
                                :avatar="item.avaurl"
                                :name="item.createRole === 'MENTEE'? item.menteeName:item.mentorName"
                                :time="item.createTime"
                                :content="item.content"></zlr-discuss-item>
            </template>
            <zlr-empty v-else></zlr-empty>
          </zlr-discuss>
        </div>
      </div>
    </div>
    <!-- 发表讨论 -->
    <div class="essay-edit-add-dicuss"
         style="display:none;">
      <div>
        <div>
          <discuss-add title="Add discussion"
                       v-model="discuss"
                       :avatar="userAvatar"
                       ref="addDiscuss">
            <Button class="zlr-btn-primary"
                    :loading="isSub"
                    @click="handleSend">Send</Button>
          </discuss-add>
          <!-- <div class="essay-edit-publish-remind">
            <Checkbox>Also send my conments to EM mentor</Checkbox>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { createComments, getCommentsPage } from '@/api/comments'
// components
import EssayList from './components/essay-modify-list'
import discuss from '_c/discuss'
import DiscussAdd from '_c/discuss-add/discuss-add'
import ZlrEmpty from '_c/empty/empty'
import { mapState } from 'vuex'
export default {
  name: 'mentee-program-essay-edit',
  components: {
    EssayList,
    ZlrDiscuss: discuss.ZlrDiscuss,
    ZlrDiscussItem: discuss.ZlrDiscussItem,
    DiscussAdd,
    ZlrEmpty
  },
  data () {
    return {
      programId: this.$route.params.programId,
      discuss: '',
      commentList: [],
      isSub: false
    }
  },
  computed: {
    ...mapState({
      'userAvatar' (state) {
        return state.user.userAvatar
      }
    })
  },
  mounted () {
    this.getCommentsPage()
  },
  methods: {
    // 获取评论列表
    getCommentsPage () {
      getCommentsPage({
        projectId: this.programId,
        type: 'PROJECT'
      }).then(res => {
        this.commentList = res.data.page.result
      })
    },
    // 发表评论
    handleSend () {
      if (!this.discuss) return false
      this.isSub = true
      createComments({
        type: 'PROJECT',
        projectId: this.programId,
        content: this.discuss
      }).then(res => {
        this.$refs['addDiscuss'].resetHtml()
        this.getCommentsPage()
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.isSub = false
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
